var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }